
import {SMStokenService} from "@/services/smstoken.service";

const state = {
    overlay: false,
    loading: false,
    dialog: false,
    denoms: [{
        jml:1
    }],
    orders: [],
    ordertotal:0,
    historitotal: 0,
    totalamountorder: 0,
    totaltoken: 0,
    historitoken: [],
    order:{}
}
const actions = {
    closedialog({commit}){
        commit('closedialog');
    },
    opendialog({commit}){
        commit('opendialog');
    },
    getDenoms({ commit }) {
        SMStokenService.listdenom().then(data => {
            commit('adddenomdata', data);
        }, error => {
            console.log(error);
        });
    },
    getOrders({ commit },opti) {
        commit('clearOrders');
        SMStokenService.listOrders(opti).then(data => {
            commit('addOrderdata', data);
        }, error => {
            console.log(error);
        });
    },
    getHistoriToken({ commit },opti) {
        commit('clearHistoriToken');
        commit('setloading',true);
        SMStokenService.Historitoken(opti).then(data => {
            commit('setloading',false);
            commit('addHistoriToken', data);
        }, error => {
            console.log(error);
        });
    },
    getOrdersByid({ commit },orderid) {
        commit('clearOrders');
        SMStokenService.OrderById(orderid).then(data => {
            commit('addOrderIddata', data);
        }, error => {
            console.log(error);
        });
    },
    doCreateOrder({commit},data){
        commit('setloading',true);
        SMStokenService.doCreateOrder(data).then((res)=>{
            commit('setloading',false);
            window.getApp.$emit('ORDER_SUCCESS',res.data.order);
            console.log(res);
        }).catch((err)=>{
            console.log(err);
        })
    }
}
const mutations ={
    closedialog(state){
        state.dialog = false;
    },
    opendialog(state){
        state.dialog = true;
    },
    setloading(state,load) {
        state.loading = load
        state.overlay = load;
    },
    adddenomdata(state, Adata) {
        console.log(denoms);
        var denoms = Adata.data;
        state.denoms = []
        for (var i = 0; i < denoms.length; i++) {
            state.denoms.push({
                id:denoms[i].id,
                jml:1,
                name:denoms[i].name,
                jmltoken:denoms[i].jumlahToken,
                price:denoms[i].price});
        }

        // state.denoms= [{ "id": 1,jml:1, "name": "PAKET A", "jumlahToken": 100, "price": 50000, "enable": 1, "updatedby": "1", "createdat": "2019-11-21T06:21:10", "updatedat": "2020-08-03T01:52:44" }]
        state.loading = false;
        state.dialog = false;
    },
    clearOrders(state){
        state.orders = [];
        state.totalamountorder=0;
    },
    clearHistoriToken(state){
        state.historitoken = [];
    },
    addOrderIddata(state, orders) {
        state.order= orders.data
        state.loading = false
        state.dialog = false
    },
    addOrderdata(state, orders) {
        state.orders = []
        state.totalamountorder=0;
        state.totaltoken=0
        state.orders= orders.data.content
        for (var i = 0; i <  state.orders.length; i++) {
            state.totalamountorder=state.totalamountorder+state.orders[i].price
            state.totaltoken= state.totaltoken+state.orders[i].totaltokensms
        }
        state.ordertotal= orders.data.totalElements
        state.loading = false;
        state.dialog = false;
    },
    addHistoriToken(state, history) {
        state.historitoken = []
        state.historitoken= history.data.content
        state.historitotal = history.data.totalElements
        state.loading = false;
        state.dialog = false;
    }
}

export const TokenSMS = {
    namespaced: true,
    state,
    actions,
    mutations
};
